import React, { useState } from 'react';

const API = 'http://localhost:8000/api/v1';

function Login({ onLogin }) {
  const [email, setEmail] = useState('demo@khepri.ru');
  const [password, setPassword] = useState('demo123');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(API + '/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Error');
      onLogin(data.token, data.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <div style={{ background: '#1E293B', padding: 40, borderRadius: 12, border: '1px solid #334155', width: '100%', maxWidth: 400, textAlign: 'center' }}>
        <h1 style={{ fontSize: 28, marginBottom: 8 }}>Khepri</h1>
        <p style={{ color: '#94A3B8', marginBottom: 24, fontSize: 14 }}>Operating system for business</p>
        <form onSubmit={handleSubmit}>
          <input style={{ width: '100%', padding: 12, marginBottom: 12, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC', fontSize: 14 }} type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
          <input style={{ width: '100%', padding: 12, marginBottom: 12, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC', fontSize: 14 }} type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
          {error && <p style={{ color: '#EF4444', fontSize: 13, marginBottom: 8 }}>{error}</p>}
          <button style={{ width: '100%', padding: 14, background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 600, cursor: 'pointer', marginTop: 8 }} type="submit" disabled={loading}>{loading ? 'Loading...' : 'Login'}</button>
        </form>
        <p style={{ color: '#94A3B8', fontSize: 12, marginTop: 16 }}>Demo: demo@khepri.ru / demo123</p>
      </div>
    </div>
  );
}

export default Login;